export default __webpack_public_path__ + "static/media/delta-theta.76c4fb42.jpg";